function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 389",
  d: "M48.1 124.26c30.43 0 47.6-25.16 47.6-61.88S78.53.5 48.1.5C17.84.5.5 25.66.5 62.38s17.34 61.88 47.6 61.88zm0-22.95c-15.98 0-24.14-13.77-24.14-38.93s8.16-39.1 24.14-39.1 24.31 13.94 24.31 39.1-8.33 38.93-24.31 38.93zm55.08 20.57h79.56V99.27h-44.71l23.29-23.29c11.22-11.22 19.55-23.63 19.55-38.08C180.87 14.1 162 .5 141.6.5c-16.15 0-31.62 8.16-39.27 25.16l19.72 11.56c3.91-8.5 10.71-13.94 19.89-13.94 9.01 0 15.47 5.95 15.47 15.47 0 7.99-5.95 15.81-13.6 23.8l-40.63 41.82z",
  fill: "none",
  stroke: "#3c00dc"
});

function SvgNumber02Inline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 183.24,
    height: 124.76,
    viewBox: "0 0 183.24 124.76"
  }, props), _ref);
}

export default SvgNumber02Inline;